export const Calendar = () => {
  return (
    <svg viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.2222 2.25H2.77778C1.79594 2.25 1 3.0335 1 4V16.25C1 17.2165 1.79594 18 2.77778 18H15.2222C16.2041 18 17 17.2165 17 16.25V4C17 3.0335 16.2041 2.25 15.2222 2.25Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 6H17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 1V4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 1V4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1 10H17" stroke="currentColor" strokeLinecap="round" />
      <path d="M5 18L5 6" stroke="currentColor" strokeLinecap="round" />
      <path d="M9 18L9 6" stroke="currentColor" strokeLinecap="round" />
      <path d="M13 18L13 6" stroke="currentColor" strokeLinecap="round" />
      <path d="M1 14H17" stroke="currentColor" strokeLinecap="round" />
    </svg>
  )
}
